import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axios'
import Swal from 'sweetalert2';
import { login } from '../../utils/urls';
import { setIdleTimeoutSeconds } from '../../utils/session';
import jwt_decode from "jwt-decode";
import { useDispatch } from 'react-redux';
import { setUser } from '../../utils/userSlice';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import FlexComponent from '../FlexComponent';
import googleImage from '../../Images/googleImage.png'
import { Button } from 'primereact/button';
import ForgotPassword from './ForgotPassword';


function LoginFormWithoutOtp({isMobileView = false}) {

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [forgotPassword, setForgotPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authTokens")) {
      const prevUrl = localStorage.getItem("prevUrl");
      navigate(prevUrl);
    }
  }, [navigate])

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true)
    if (!username) {
      setUsernameError('Username is required');
    }
    else {
      setUsernameError('');
    }
    if (!password) {
      setPasswordError('Password is required');
    }
    else {
      setPasswordError('');
    }
    if (username && password) {

      const body = JSON.stringify({
        username,
        password,
      });

      axios
        .post(login, body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          setLoading(false)
          if (response.status === 200) {
            const decoded_token = jwt_decode(response.data.access)
            console.log("decoded_token", decoded_token);
            console.log("dataaa" , response.data);
            
            localStorage.setItem('authTokens', JSON.stringify(response.data))
            setIdleTimeoutSeconds(response.data.idle_timeout_seconds)
            localStorage.setItem('activePipeline', response.data.active_pipeline_account)
            localStorage.setItem('appPipeline', response.data.app_pipeline_account)
            localStorage.setItem('defaultLanguage', response.data.languages)
            dispatch(setUser({ userId: decoded_token.user_id, isSuperuser: decoded_token.is_superuser, designation : decoded_token?.designation || "", activePipeline : response.data.active_pipeline_account, appPipeline : response.data.app_pipeline_account, defaultLanguage : response.data.languages, bizCardUrl: decoded_token.biz_card_url || null, locationCardUrl: decoded_token.location_card_url || null, languages: decoded_token.languages || [] }));
            navigate("/");
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Login Successfully",
              showConfirmButton: false,
              timer: 1500,
            });

          }
          else {
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Invalid Credentials",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        }).catch((err) => {
          console.log(err)
          setLoading(false)
          const detail = err.response?.data?.detail;
          Swal.fire({
            position: "center",
            icon: "warning",
            title: detail || "Invalid Credentials",
            showConfirmButton: false,
            timer: detail ? 4000 : 1500,
          });
        });
    }
  }


  if (forgotPassword) {
    return <ForgotPassword onBackToLogin={() => setForgotPassword(false)} />;
  }

  return (
    <FlexComponent justifyContent="center" >
      <form onSubmit={handleLogin} style={{ zIndex: "1" }} >
        {/* <h2 style={{ color: "white"}}>Hello Again!</h2> */}
        <p style={{ fontSize: '18px', color: "white" }}>Log in to breadcrumbs</p>
        <div style={{ marginTop: '1rem' }}>
          <div className="p-inputgroup flex-1 login-input-div" style={{ width: '400px' }}>
            {/* <span className="p-inputgroup-addon" style={{background: 'white'}}>
              <i className="pi pi-user"></i>
            </span> */}
            <InputText
              // style={{background: 'rgba(255, 255, 255, 0.06)', boxShadow: '-2px -2px 0px',  border:"none", filter: 'blur(0px)', backdropFilter: 'blur(10px)'}}
              placeholder="Username"
              required
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
          </div>
          <div className="p-inputgroup flex-1 login-input-div" style={{ width: '400px', marginTop: '1rem' }}>
            {/* <span className="p-inputgroup-addon" style={{background: 'white'}}>
            <i className="pi pi-lock"></i>
          </span> */}
            <Password
              placeholder="Password"
              feedback={false}
              value={password}
              // style={{background: 'rgba(255, 255, 255, 0.06)', boxShadow: '-2px -2px 0px',  border:"none", filter: 'blur(0px)', backdropFilter: 'blur(10px)'}}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div style={{ textAlign: 'right', marginTop: '0.6rem' }}>
            <span
              role="button"
              tabIndex={0}
              className="otp-link"
              onClick={() => setForgotPassword(true)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setForgotPassword(true); }}
              style={{ color: 'white', fontSize: '14px' }}
            >
              Forgot Password?
            </span>
          </div>
        </div>

        <Button type="submit" loading={loading} label='Login'
          style={{ width: isMobileView ? "100%" : '400px', cursor: 'pointer', background: 'white', color: 'black', fontSize: '16px', fontWeight: '500', padding: '10px', border: 'none', marginTop: '1rem', borderRadius: '5px' }} />


        <hr className="hr-text" />

        {/* <p>Login with <a className='otp-link' onClick={()=> setOtpLogin(!otpLogin)}>{!otpLogin ? 'OTP' : 'CREDENTIALS'}</a></p> */}
        <div style={{ fontSize: "14px", color: "white", width: "100%", textAlign: "center", border: "1px #333333 solid", padding: "1rem", borderRadius: "10px" }} >Don’t have an account? Sign Up →</div>
        <div style={{ color: "#333333", width: "100%", textAlign: "center", padding: "1rem", borderRadius: "10px" }} >or</div>
        <div style={{ width: "100%", textAlign: "center" }}>
          <img src={googleImage} width={60} alt="" />
        </div>

      </form>

    </FlexComponent>
  )
}

export default LoginFormWithoutOtp